import _ from 'underscore';

import {DataFrameSpec} from 'data-frames/DataFrameTypes';
import {ColumnHeaderTransformOptions} from 'data-frames/header-menu/DataFrameHeaderMenuOptions';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';

/**
 * Get `DataFrameHideColumnOptions`, used to inject logic for hiding columns into a data frame table.
 *
 * @package
 */
export default function getHideColumnOptions(
  dataFrameSpec: DataFrameSpec,
  currentConfig: PipelineStepConfig<PipelineStepType.HIDE_COLUMNS, 0> | null,
  updateConfig: (newConfig: PipelineStepConfig<PipelineStepType.HIDE_COLUMNS, 0>) => Promise<void>,
  deleteStep: () => Promise<void>
): ColumnHeaderTransformOptions[PipelineStepType.HIDE_COLUMNS] {
  const hideColumn = (columnSystemName: string) => {
    if (currentConfig == null) {
      return updateConfig({columns: [columnSystemName], columnsToKeep: []});
    } else if (currentConfig.columnsToKeep && currentConfig.columnsToKeep.length > 0) {
      return updateConfig({
        columns: [],
        columnsToKeep: currentConfig.columnsToKeep.filter((column) => column !== columnSystemName),
      });
    } else {
      return updateConfig({
        columns: _.unique([...(currentConfig.columns ?? []), columnSystemName]),
        columnsToKeep: [],
      });
    }
  };

  const disabledMessage =
    dataFrameSpec.columns.length <= 1 ? 'Cannot hide the only column in the table' : undefined;

  return {hideColumn, disabledMessage};
}
